import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import { getAction, httpAction } from '@api/manage';
import pick from 'lodash.pick';
import moment from 'moment';
import IwsUpload from '@comp/upload/IwsUpload';
import SelectAssetChemicalModal from '@views/assets/SelectAssetChemicalModal1';
import SelectAssetModal from '@views/assets/SelectAssetModal'; // import { text } from 'stream/consumers'

var columnsItem = [{
  title: '仪表名称',
  dataIndex: 'instrumentId',
  fixed: 'left',
  align: 'center',
  width: '200px',
  scopedSlots: {
    customRender: 'instrumentId'
  }
}, {
  title: '标物名称',
  dataIndex: 'chemicalId',
  fixed: 'left',
  align: 'center',
  width: '200px',
  scopedSlots: {
    customRender: 'chemicalId'
  }
}, {
  title: '使用数量',
  dataIndex: 'usageAmount',
  fixed: 'left',
  align: 'center',
  width: '200px',
  scopedSlots: {
    customRender: 'usageAmount'
  }
}, {
  title: '校准值',
  dataIndex: 'calibrationValue',
  // fixed: 'left',
  // align: 'center',
  // width: '200px',
  scopedSlots: {
    customRender: 'calibrationValue'
  }
}, // {
//   title: '校准值单位',
//   dataIndex: 'calibrationUnit',
//   fixed: 'left',
//   align: 'center',
//   width: '200px',
//   scopedSlots: {
//     customRender: 'calibrationUnit',
//   },
// },
{
  title: '仪器测定值',
  dataIndex: 'measuredValue',
  align: 'center',
  // width: '7%',
  scopedSlots: {
    customRender: 'measuredValue'
  }
}, {
  title: '绝对误差',
  dataIndex: 'absoluteError',
  align: 'center',
  // width: '7%',
  scopedSlots: {
    customRender: 'absoluteError'
  }
}, {
  title: '相对误差(%)',
  dataIndex: 'relativeError',
  align: 'center',
  // width: '10%',
  scopedSlots: {
    customRender: 'relativeError'
  }
}, {
  title: '校准结果是否合格',
  dataIndex: 'calibrationRes',
  align: 'center',
  // width: '10%',
  scopedSlots: {
    customRender: 'calibrationRes'
  }
}, {
  title: '关键参数是否上报',
  dataIndex: 'report',
  align: 'center',
  // width: '10%',
  scopedSlots: {
    customRender: 'report'
  }
}, {
  title: '校准时间',
  dataIndex: 'calibrationTime',
  align: 'center',
  // width: '10%',
  scopedSlots: {
    customRender: 'calibrationTime'
  }
}, {
  title: '备注',
  dataIndex: 'remark',
  align: 'center',
  // width: '14%',
  scopedSlots: {
    customRender: 'remark'
  }
}, {
  title: '附件',
  align: 'center',
  width: '80px',
  dataIndex: 'operation',
  scopedSlots: {
    customRender: 'operation'
  }
}];
export default {
  name: 'InstrumentCalibrationDrawer',
  mixins: [ModalFormMixin, GetSiteIdMixin],
  components: {
    IwsUpload: IwsUpload,
    SelectAssetChemicalModal: SelectAssetChemicalModal,
    SelectAssetModal: SelectAssetModal
  },
  data: function data() {
    return {
      url: {
        queryInstrumentName: '/ea/asset/info/queryBySiteId/',
        queryInstrumentCalibrationItem: '/om/instrument/calibration/item/',
        deleteInstrumentCalibrationItem: '/om/instrument/calibration/item/'
      },
      title: '仪器校准表单',
      codeDict: 'instrumentId,chemicalId,calibrationValue,measuredValue,absoluteError,relativeError,remark',
      tableName: 'om_instrument_calibration',
      form_fields: ['siteId', 'userId', 'category', 'remark', 'tenantId'],
      form_fields_time: ['calibrationDate'],
      tabsKey: '1',
      tablePageIndex: 1,
      addState: false,
      columnsItem: columnsItem,
      tableData: [],
      dataItem: [],
      validatorRules: {
        category: {
          rules: [{
            required: true,
            message: '请选择校准类型!'
          }],
          initialValue: '3'
        },
        userId: {
          rules: [{
            required: true,
            message: '请选择运维人员!'
          }]
        },
        calibrationDate: {
          rules: [{
            required: true,
            message: '请选择校准时间!'
          }]
        }
      },
      columns: [{
        title: '名称',
        dataIndex: 'title',
        width: '300px',
        align: 'center'
      }, {
        title: '值',
        dataIndex: 'value',
        align: 'center',
        width: '300px',
        scopedSlots: {
          customRender: 'value'
        }
      }, {
        title: '附件',
        dataIndex: 'action',
        align: 'center',
        scopedSlots: {
          customRender: 'action'
        }
      }],
      instrumentNameList: [],
      selectedAssetChemical: [],
      tableKey: '',
      tableKey1: '',
      loginUser: '',
      dataSource: [],
      InstrumentCalibrationItem: []
    };
  },
  props: {
    pagePath: String,
    userTree: Array
  },
  created: function created() {
    this.loginUser = this.$store.getters.userInfo.id;
  },
  watch: {
    currentSiteId: function currentSiteId(value) {
      this.siteId = value;
    },
    currentSiteName: function currentSiteName(newVal) {
      this.siteName = newVal;
    }
  },
  methods: {
    selectAssetChemical: function selectAssetChemical(index1) {
      // console.log('record', record)
      this.tableKey = index1;
      this.$refs.AssetChemicalModal.category = 23;
      this.$refs.AssetChemicalModal.disableSubmit = true;
      this.$refs.AssetChemicalModal.add(this.selectedAssetChemical, this.assetChemicalIds);
    },
    // 子modal回调
    choseAssetChemical: function choseAssetChemical(productList) {
      var _this = this;

      console.log(productList);
      this.dataItem.forEach(function (e, index) {
        if (index === _this.tableKey) {
          e.chemicalId = productList[0].id;
          e.chemicalName = productList[0].name + '(' + productList[0].unit_dictText + ')';
        }
      });
      this.$forceUpdate();
      console.log(this.dataItem);
    },
    addTable: function addTable() {
      var _this2 = this;

      console.log('this.model', this.model);

      var newData = _toConsumableArray(this.dataItem);

      console.log('newData', newData);
      newData.push({
        instrumentId: '',
        chemicalId: '',
        usageAmount: '',
        usageAmountUnit: '',
        calibrationValue: '',
        calibrationUnit: '',
        measuredValue: '',
        measuredUnit: '',
        absoluteError: '',
        absoluteUnit: '',
        relativeError: '',
        calibrationRes: '',
        report: '',
        remark: '',
        calibrationTime: '',
        editable: true
      });
      this.dataItem = newData;
      var dataObj = {
        instrumentId: '',
        chemicalId: '',
        usageAmount: '',
        usageAmountUnit: '',
        calibrationValue: '',
        calibrationUnit: '',
        measuredValue: '',
        measuredUnit: '',
        absoluteError: '',
        absoluteUnit: '',
        relativeError: '',
        calibrationRes: '',
        report: '',
        remark: '',
        calibrationTime: '',
        editable: true
      };
      var arr = [];
      this.columnsItem.forEach(function (item, index) {
        if (index < _this2.columnsItem.length - 1) {
          var dataItem = {
            title: item.title,
            code: item.dataIndex,
            value: item.dataIndex == 'calibrationTime' ? moment(new Date(), 'YYYY-MM-DD HH:mm:ss') : null
          };

          if (_this2.codeDict.indexOf(dataItem.code) > -1) {
            dataItem.fileSrc = "om_instrument_calibration_item_".concat(dataItem.code);
            dataItem.srcId = null;
          }

          arr.push(dataItem);
        }
      });
      this.tableData.push(arr);
      this.tablePageIndex = this.tableData.length;
      console.log('tableData', this.tableData);
    },
    handleDelete: function handleDelete(id) {
      var _this3 = this;

      if (this.tableData.length <= 0) return;

      if (id) {
        this.tableData.splice(this.tablePageIndex - 1, 1);
        this.dataItem.splice(this.tablePageIndex - 1, 1);
        httpAction(this.url.deleteInstrumentCalibrationItem + '?id=' + id, '', 'DELETE').then(function (res) {
          if (res.success) {
            _this3.$notification.success({
              message: res.message
            });
          } else {
            _this3.$notification.warning({
              message: res.message
            });
          }
        });
      } else {
        this.tableData.splice(this.tablePageIndex - 1, 1);
        this.dataItem.splice(this.tablePageIndex - 1, 1);
      }

      if (this.tableData.length > 1 && this.tablePageIndex > 1) {
        this.tablePageIndex--;
      } else {
        this.tablePageIndex = 1;
      }
    },
    changeUpload: function changeUpload(e, record) {
      e.sysFileList.forEach(function (item) {
        item.fileSrc = record.fileSrc;
      });
      e.fileDelList.forEach(function (item) {
        item.fileSrc = record.fileSrc;
      });
      console.log('e,record', e, record);
      record.sysFileList = e.sysFileList;
      record.fileDelList = e.fileDelList;
      console.log('this', this.tableData);
    },
    moment: moment,
    getCalibrationUnit: function getCalibrationUnit(index, e) {
      this.dataItem[index].calibrationUnit = e;
    },
    getMeasuredUnit: function getMeasuredUnit(index, e) {
      this.dataItem[index].measuredUnit = e;
    },
    getAbsoluteErrorUnit: function getAbsoluteErrorUnit(index, e) {
      this.dataItem[index].absoluteUnit = e;
    },
    getUsageAmountUnit: function getUsageAmountUnit(index, e) {
      this.dataItem[index].usageAmountUnit = e;
    },
    getUsageAmount: function getUsageAmount(record, value) {
      if (record) {
        if (value != '') {
          if (value < 0) {
            this.$message.warning('产品数量不能为负数');
          } else {
            record.value = value;
          }
        }
      }
    },
    getCalibrationValue: function getCalibrationValue(record, value) {
      if (record) {
        if (value != '') {
          if (value < 0) {
            this.$message.warning('产品数量不能为负数');
          } else {
            record.value = value;
          }
        }
      }
    },
    getMeasuredValue: function getMeasuredValue(record, value) {
      if (record) {
        if (value != '') {
          if (value < 0) {
            this.$message.warning('产品数量不能为负数');
          } else {
            record.value = value;
          }
        }
      }
    },
    getData: function getData(value, e) {
      value['value'] = e;
    },
    getCalibrationStatus: function getCalibrationStatus(value, e) {
      value['value'] = e;
    },
    add: function add() {
      this.dataItem = [];
      this.tableData = [];
      this.edit({
        siteId: this.siteId
      }, true);
      this.addState = true;
    },
    edit: function edit(record) {
      var _this4 = this;

      this.tabsKey = '1';
      this.addState = false;
      this.form.resetFields();
      this.model = Object.assign({}, record);
      console.log('model:', this.model);
      this.visible = true;

      if (!this.model.id) {
        this.model.userId = this.loginUser;
        this.model.siteName = this.siteName;
        this.model.calibrationDate = moment(new Date(), 'YYYY-MM-DD HH:mm:ss');
        this.getInstrumentNameList();
      } else {
        this.getInstrumentCalibrationItem();
      }

      this.$nextTick(function () {
        var that = _this4;
        that.form.setFieldsValue(pick(that.model, that.form_fields)); //时间格式化

        var timeVal = {};
        that.form_fields_time.forEach(function (item, index) {
          timeVal[item] = that.model[item] ? moment(that.model[item], 'YYYY-MM-DD HH:mm:ss') : null;
        });
        that.form.setFieldsValue(timeVal);
        that.$refs.iwupload.loadUploadFiles();
      });
    },
    selectAssets: function selectAssets(record, index, index1) {
      this.tableKey1 = index1;
      this.selectedRecord = record;
      this.$refs.AssetListModal.siteId = this.siteId;
      this.$refs.AssetListModal.disableSubmit = true;
      this.$refs.AssetListModal.add(record.productName, record.equipmentId);
    },
    choseProduct: function choseProduct(productList) {
      var _this5 = this;

      this.dataItem.forEach(function (e, index) {
        if (index === _this5.tableKey1) {
          e.instrumentId = productList[0].id;
          e.instrumentName = productList[0].productName;
        }
      });
      console.log('this.dataItem', this.dataItem);
      this.$forceUpdate();
    },
    getInstrumentNameList: function getInstrumentNameList() {
      var _this6 = this;

      getAction(this.url.queryInstrumentName + this.siteId).then(function (res) {
        if (res.success) {
          _this6.instrumentNameList = res.result;
        }
      });
    },
    handleOk: function handleOk() {
      var _this7 = this;

      var that = this; // this.visible1 = false
      // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var formData = Object.assign(that.model, values); //时间格式化

          formData.calibrationDate = formData.calibrationDate ? formData.calibrationDate.format('YYYY-MM-DD HH:mm:ss') : null;
          formData = _this7.$refs.iwupload.getUploadListToFromData(formData);
          formData.siteId = _this7.siteId;
          var arr = [];
          console.log('dataItem', _this7.dataItem);
          console.log('arr', _this7.tableData);
          var tableData = [];

          _this7.tableData.forEach(function (item, index) {
            var obj = {};
            var sysFileList = [];
            var fileDelList = [];
            item.forEach(function (item2, index2) {
              obj[item2.code] = item2.value;

              if (item2.code == 'calibrationTime') {
                obj.calibrationTime = item2.value ? item2.value.format('YYYY-MM-DD HH:mm:ss') : null;
              }

              if (item2.sysFileList) {
                sysFileList = sysFileList.concat(item2.sysFileList);
                fileDelList = fileDelList.concat(item2.fileDelList);
              }
            });
            obj['instrumentId'] = _this7.dataItem[index].instrumentId;
            obj['chemicalId'] = _this7.dataItem[index].chemicalId;
            obj['absoluteUnit'] = _this7.dataItem[index].absoluteUnit;
            obj['calibrationUnit'] = _this7.dataItem[index].calibrationUnit;
            obj['usageAmountUnit'] = _this7.dataItem[index].usageAmountUnit;
            obj['measuredUnit'] = _this7.dataItem[index].measuredUnit;
            obj['id'] = _this7.dataItem[index].id;
            obj.sysFileList = sysFileList;
            obj.fileDelList = fileDelList;
            console.log('obj', obj);
            tableData.push(obj);
          });

          formData.instrumentCalibrationItemVos = tableData;
          var httpurl = '',
              method = '';

          if (!_this7.model.id) {
            httpurl = _this7.url.add ? _this7.url.add : _this7.pagePath;
            method = 'post';
          } else {
            httpurl = _this7.url.edit ? _this7.url.edit : _this7.pagePath;
            method = 'put';
          }

          console.log('formData', formData);
          httpAction(httpurl, formData, method).then(function (res) {
            console.log('res', res);

            if (res.success) {
              _this7.$refs.iwupload.resetUploadFiles();

              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    // 获取表格数据
    getInstrumentCalibrationItem: function getInstrumentCalibrationItem() {
      var _this8 = this;

      if (this.model.id != null) {
        getAction(this.url.queryInstrumentCalibrationItem + this.model.id).then(function (res) {
          if (res.success) {
            _this8.InstrumentCalibrationItem = res.result;

            _this8.getSiteDevice(_this8.InstrumentCalibrationItem);
          } else {
            _this8.getSiteDevice(_this8.InstrumentCalibrationItem);
          }
        });
      } else {
        this.getSiteDevice(this.InstrumentCalibrationItem);
      }
    },
    getSiteDevice: function getSiteDevice(InstrumentCalibrationItem) {
      var _this9 = this;

      this.getInstrumentNameList();
      var arr = [];
      var arr3 = [];
      InstrumentCalibrationItem.forEach(function (item) {
        var _data;

        var data = (_data = {
          instrumentId: item.instrumentId,
          absoluteError: item.absoluteError,
          chemicalId: item.chemicalId,
          usageAmount: item.usageAmount,
          calibrationValue: item.calibrationValue,
          measuredValue: item.measuredValue
        }, _defineProperty(_data, "absoluteError", item.absoluteError), _defineProperty(_data, "relativeError", item.relativeError), _defineProperty(_data, "report", item.report), _defineProperty(_data, "calibrationRes", item.calibrationRes), _defineProperty(_data, "remark", item.remark), _defineProperty(_data, "calibrationTime", item.calibrationTime), _data);
        var arr1 = [];
        var arr2 = [];

        _this9.columnsItem.forEach(function (item1, index) {
          if (index < _this9.columnsItem.length - 1) {
            var tableData = {
              title: item1.title,
              code: item1.dataIndex,
              value: data[item1.dataIndex]
            };

            if (tableData.code == 'calibrationTime') {
              tableData.value = tableData.value ? moment(tableData.value, 'YYYY-MM-DD HH:mm:ss') : null;
            }

            if (_this9.codeDict.indexOf(tableData.code) > -1) {
              tableData.fileSrc = "om_instrument_calibration_item_".concat(tableData.code);
              tableData.srcId = item.id;
            }

            arr1.push(tableData);
            arr2.push(tableData);
            arr2.chemicalName = item.chemicalName;
            arr2.absoluteUnit = item.absoluteUnit;
            arr2.measuredUnit = item.measuredUnit;
            arr2.calibrationUnit = item.calibrationUnit;
            arr2.usageAmountUnit = item.usageAmountUnit;
            arr2.chemicalId = item.chemicalId;
            arr2.instrumentId = item.instrumentId;
            arr2.instrumentName = item.instrumentName;
            arr2.id = item.id;
          }
        });

        arr.push(arr1);
        arr3.push(arr2);
      });
      this.tableData = arr;
      this.dataItem = arr3;
      console.log('this.tableData', this.tableData);
      console.log('this.dataItem', this.dataItem);
    }
  }
};